/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InvoicePaymentsAdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Historique des paiements en ligne d'une entreprise
     * Du plus recent au plus ancien, 20 par page (`data`, `current_page`, `last_page`, `total`).
     * @param customerId
     * @returns string
     * @throws ApiError
     */
    public invoicePaymentsAdminIndex(
        customerId: number,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/invoice-payments',
            query: {
                'customer_id': customerId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
}
